
import { Component, Mixins } from "vue-property-decorator";
import { Vector, Rectangle, Point} from "../../../../../../../base/domain/drawing";
import { IVectorCoordinateEditable } from "../../../../../../domain/editableFormat/properties";
import { VectorPropertyEditableMixin } from "../../../mixins";

@Component
export default class VectorCoordinateEditableMixin extends Mixins(VectorPropertyEditableMixin) {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IVectorCoordinateEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IVectorCoordinateEditable) => T, defaultValue: T) => T;

  get isVectorCoordinateEditable(): boolean {
    return this.isVectorEditable;
  }

  get vectorCoordinate(): Vector {
    return this.vector;
  }

  set vectorCoordinate(value: Vector) {
    this.vector = value;
  }

  get rectangleCoordinate(): Rectangle {
    return Rectangle.from(this.vectorCoordinate);
  }

  get from(): Point {
    return this.readPropertyOrDefault(s => Point.from(s.from().getValue()), new Point(0, 0));
  }

  set from(value: Point) {
    this.writePropertyWhenValid(s => s.from().setValue(Point.to(value)));
  }

  get to(): Point {
    return this.readPropertyOrDefault(s => Point.from(s.vector().getValue().to), new Point(0, 0));
  }
  
  set to(value: Point) {
    this.writePropertyWhenValid(s => s.to().setValue(Point.to(value)));
  }
}
